const OrderStatuses = Object.freeze({
  APPROVED: "Approved",
  PACKED: "Packed",
  DISPATCHED: "Dispatched",
  COMPLETED: "Completed",
});

export { OrderStatuses };
